<app-nav
  [class.is-mobile]="deviceService.isMobile()"
  [class.is-tablet]="deviceService.isTablet()"
></app-nav>
<!-- <div class="social" appSocial [isMobile]="isMobile" *ngIf="!isMobile && !isTablet">
    <div class="separator">
        <span></span>
    </div>
    <a href="https://instagram.com/lesexplorateurs.dumonde" target="_blank">
        <img ngSrc="/icons/instagram.svg" width="16" height="16" alt="instagram" />
    </a>
    <a href="https://facebook.com/lesexplorateursdumonde" target="_blank">
        <img ngSrc="/icons/facebook.svg" width="16" height="16" alt="facebook" />
    </a>
    <a href="https://tiktok.com/@lesexplorateursdumonde" target="_blank">
        <img ngSrc="/icons/tiktok.svg" width="16" height="16" alt="tiktok" />
    </a>
    <a href="https://youtube.com/channel/UCwWohrVcLOeUztcfJ7bf3Ww" target="_blank">
        <img ngSrc="/icons/youtube.svg" width="16" height="16" alt="youtube" />
    </a>
</div> -->
<div
  [class.is-mobile]="deviceService.isMobile()"
  [class.is-tablet]="deviceService.isTablet()"
  class="full-width content-container"
>
  <router-outlet></router-outlet>
</div>
@if (!isAdmin) {
<app-footer [class.is-mobile]="deviceService.isMobile()"></app-footer>
}
